<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Daftar Customer</font>
          &nbsp;&nbsp;&nbsp;
          <font class="h5 text-warning border rounded p-1">{{ tanggal }}</font>
        </p>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4"></b-col>
          <b-col>
            <b-row align="right" class="text-right">
              <b-col></b-col>
              <b-col md="6" align="right" class="text-right">
                <b-input-group class="text-right">
                  <b-input-group-text
                    class="bg-white border-right-0"
                    slot="prepend"
                  >
                    <img src="@/assets/filter.svg" alt />
                  </b-input-group-text>
                  <b-dropdown
                    text="Filter Data"
                    variant="light"
                    toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                    slot="append"
                  >
                    <b-dropdown-item
                      :style="status == '' ? 'background: #f8f9fc' : ''"
                      @click="statusFilter('')"
                    >
                      <span>All</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-for="data in dataStatus"
                      :key="data"
                      :style="status == data.value ? 'background: #f8f9fc' : ''"
                      @click="statusFilter(data.value)"
                    >
                      <span v-if="data.value == 'new'" class="text-warning">{{
                        data.description.id
                      }}</span>
                      <span
                        v-else-if="data.value == 'rejected'"
                        class="text-danger"
                        >{{ data.description.id }}</span
                      >
                      <span
                        v-else-if="data.value == 'onprogress'"
                        class="text-info"
                        >{{ data.description.id }}</span
                      >
                      <span
                        v-else-if="data.value == 'approved'"
                        class="text-primary"
                        >{{ data.description.id }}</span
                      >
                      <span v-else>{{ data.description.id }}</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </b-col>
              <b-col md="5" align="right" class="text-right">
                <download-csv
                  class="d-none"
                  :data="CSV"
                  name="CustomerList.csv"
                  ref="DownloadCSV"
                ></download-csv>
                <b-button
                  class="btn btn-primary"
                  :disabled="loadingCSV"
                  @click="downloadCSV()"
                >
                  <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner
                  >Export to CSV
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <b-card body-class="py-0 px-0">
      <b-row>
        <b-col md="4" class="border-right text-left pl-5 py-5">
          <b-row>
            <b-col>
              <h5 class>Total Calon Mitra</h5>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <h4 class="mb-0" v-else>
                {{ items ? items.total_customer : items }}
              </h4>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col md="11">
                  <b-form-group
                    id="fieldset-1"
                    label="Filter Tanggal"
                    label-for="input-1"
                  >
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="4"
                      >
                        <img
                          src="@/assets/ic-calendar-copy-30.svg"
                          width="25px"
                          alt
                          class
                        />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 "
                          placeholder="From"
                          v-model="date_from"
                          :format="customFormatter"
                          @input="customerDate()"
                          :disabledDates="element2"
                        ></datepicker>
                      </b-col>
                      <!-- <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetFromdate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>-->
                    </b-row>
                    <b-row class="m-0 mt-2">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="4"
                      >
                        <img
                          src="@/assets/ic-calendar-copy-30.svg"
                          width="25px"
                          alt
                          class
                        />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 "
                          placeholder="To"
                          v-model="date_to"
                          @input="customerDate()"
                          :format="customFormatter"
                          :disabledDates="element"
                        ></datepicker>
                      </b-col>
                      <!-- <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetTodate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>-->
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <p class="text-warning font-weight-bold mb-0">Baru</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>{{ items ? items.total_new.total : items }}</p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ items ? items.total_new.percentage.toFixed(2) : items }}%
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <p class="text-danger font-weight-bold mb-0">Ditolak</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ items ? items.total_rejected.total : items }}
              </p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ items ? items.total_rejected.percentage.toFixed(2) : items }}
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <p class="text-info font-weight-bold mb-0">Diproses</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ items ? items.total_onprogress.total : items }}
              </p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{
                  items ? items.total_onprogress.percentage.toFixed(2) : items
                }}
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="text-left pl-4 py-5">
          <p class="text-primary font-weight-bold mb-0">Diterima</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{ items ? items.total_approved.total : items }}
              </p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>
                {{
                  items ? items.total_approved.percentage.toFixed(2) : items
                }}%
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!filter"
                  @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right"></b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="customerContent"
        hover
        :items="getInfo"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="row">{{
          row.value | DateTime
        }}</template>
        <template v-slot:cell(name)="row">
          <p class="text-primary text-capitalize">{{ row.value }}</p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-warning" v-if="row.value == 'new'">Baru</p>
          <p class="text-danger" v-else-if="row.value == 'rejected'">Ditolak</p>
          <p class="text-info" v-else-if="row.value == 'onprogress'">Diproses</p>
          <p class="text-primary" v-else-if="row.value == 'approved'">
            Diterima
          </p>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            :to="{ name: 'detailBigCustomer', params: { id: item.id } }"
            class="text-primary"
            v-b-tooltip.hover
            title="View Detail"
          >
            <i class="fas fa-eye"></i>
          </router-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      dashboard: [],
      fields: [
        {
          key: "created_at",
          label: "Tanggal Submit",
          sortable: true,
          class: "text-center",
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
          class: "text-center",
        },
        {
          key: "origin_city",
          label: "Kota Asal",
          sortable: true,
          class: "text-center",
        },
        {
          key: "destination_city",
          label: "Kota Tujuan",
          sortable: true,
          class: "text-center",
        },
        {
          key: "email",
          label: "Alamat Email",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center",
        },

        { key: "action", label: "Action", class: "text-center" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: "created_at",
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      status: "",
      date_from: new Date(new Date().setDate(new Date().getDate() - 30)),
      date_to: new Date(Date.now()),
      loadingCSV: false,
      CSV: "",
      tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
      routename: null,
      customerShow: false,
      total_customer: "",
      dataStatus: "",
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  watch: {
    element: {
      handler: function (newValue) {
        if (newValue) {
          this.element = newValue;
        }
      },
      deep: true,
    },
    element2: {
      handler: function (newValue) {
        if (newValue) {
          this.element2 = newValue;
        }
      },
      deep: true,
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    element() {
      var disabledDates = {
        to: new Date(this.date_from - 8640000),
        from: new Date(Date.now() - 8640000),
      };
      return disabledDates;
    },
    element2() {
      var disabledDates = {
        from: new Date(this.date_to + 8640000),
      };
      return disabledDates;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store
      .dispatch("PaxelBigCustomerModule/getPaxelBigCustomerStatus")
      .then((response) => {
        this.dataStatus = response.data.data;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  created() {
    // Set the initial number of items
    // this.totalRows = this.items.length;
    // this.$store.watch(
    //   state => state.cxModule.report,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //   }
    // );
  },
  methods: {
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
          const vm = this;
          const formData = new FormData();
          formData.append("search_param", "");
          formData.append("sort_by", "");
          formData.append("is_sort_asc", true);
          formData.append("status", this.status);
          formData.append(
            "start_date",
            this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
          );
          formData.append(
            "end_date",
            this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
          );
          this.$store
            .dispatch("PaxelBigCustomerModule/getPaxelBigCustomerAll", formData)
            .then((response) => {
              this.CSV = response.data.data;
              setTimeout(() => {
                this.loadingCSV = false;
                this.$refs.DownloadCSV.$el.click();
              }, 1000);
            })
            .catch((error) => {
              this.loadingCSV = false;
            });
        } else {
        }
      });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    statusFilter(payload) {
      this.status = payload;
      this.$refs.customerContent.refresh();
    },
    customerDate() {
      if (this.date_to < this.date_from) {
        this.$swal({
          title: "Tanggal tidak sesuai!",
          type: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        this.$refs.customerContent.refresh();
      }
    },
    resetFromdate() {
      this.date_from = "";
      this.$refs.customerContent.refresh();
    },
    resetTodate() {
      this.date_to = "";
      this.$refs.customerContent.refresh();
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("status", this.status);
      formData.append(
        "start_date",
        this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "end_date",
        this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("PaxelBigCustomerModule/getPaxelBigCustomers", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_customer;
          callback(response.data.data.results.customers || []);
          this.loading = false;
          this.items = response.data.data.results;
          this.total_customer = response.data.data.total_customer;
        })
        .catch((error) => {
          this.loading = false;
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    date() {
      const currentDateWithFormat = "";
      this.tanggal = currentDateWithFormat;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
</style>
